import React from "react";
import { Box, Stack, TextField, IconButton, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const FuncionarioList = ({ items, onChange }) => {
  const handleItemChange = (index, key, value) => {
    const next = items.map((it, i) => (i === index ? { ...it, [key]: value } : it));
    onChange(next);
  };

  const addItem = () => onChange([...(items || []), { nome: "", horasDia: "", salario: "", horasMes: "" }]);
  const removeItem = (index) => onChange(items.filter((_, i) => i !== index));

  const calcularCustoHora = (salario, horasMes) => {
    const s = parseFloat(salario);
    const h = parseFloat(horasMes);
    if (!s || !h || h === 0) return "";
    return (s / h).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
  };

  return (
    <Box>
      <Stack spacing={1}>
        {(items || []).map((it, idx) => (
          <Stack key={idx} direction="row" spacing={1} alignItems="center">
            <TextField size="small" label="Nome" value={it.nome} onChange={(e) => handleItemChange(idx, "nome", e.target.value)} sx={{ minWidth: 220 }} />
            <TextField size="small" label="Horas/Dia" type="number" value={it.horasDia} onChange={(e) => handleItemChange(idx, "horasDia", e.target.value)} sx={{ width: 140 }} />
            <TextField size="small" label="Horas/Mês" type="number" value={it.horasMes} onChange={(e) => handleItemChange(idx, "horasMes", e.target.value)} sx={{ width: 140 }} />
            <TextField size="small" label="Salário" type="number" value={it.salario} onChange={(e) => handleItemChange(idx, "salario", e.target.value)} sx={{ width: 160 }} inputProps={{ step: "0.01" }} />
            <TextField
              size="small"
              label="Custo/Hora"
              value={calcularCustoHora(it.salario, it.horasMes)}
              sx={{ width: 140 }}
              slotProps={{ readOnly: true }}
            />
            <IconButton color="error" onClick={() => removeItem(idx)} aria-label="remover">
              <DeleteIcon />
            </IconButton>
          </Stack>
        ))}
        <Button startIcon={<AddIcon />} variant="outlined" onClick={addItem}>
          Adicionar Funcionário
        </Button>
      </Stack>
    </Box>
  );
};

export default FuncionarioList;